/**
* 数据监测 实时数据
*/
<template>
	<div class="container">
		<!-- 面包屑导航 -->
		<el-breadcrumb separator-class="el-icon-arrow-right">
			<el-breadcrumb-item :to="{ path: '/' }">数据监测</el-breadcrumb-item>
			<el-breadcrumb-item>实时数据</el-breadcrumb-item>
		</el-breadcrumb>




		<!-- 搜索筛选 -->
		<el-form :inline="true" class="user-search" label-position="left"  ref="outBox" label-width="120">
			<el-form-item  label="能源类别">
				<el-select size="small" v-model="formInline.energyType" @change="changeEnergy" style="width: 100px;">
					 <el-option
					  v-for="item in energyTypeList"
					  :key="item.id"
					  :label="item.value"
					  :value="item.id">
					</el-option>
				</el-select>
			</el-form-item>
			<el-form-item >
				<el-popover  v-model="visible">
					<el-input class="cp" readonly slot="reference" style="width: 280px;" autosize size="small" value="" placeholder="选择部门/集中器" v-model="getJZ"></el-input>
					</el-tooltip>
					<el-tree :data="treeDate"  :expand-on-click-node="false" :highlight-current="true"  @node-click="handleNodeClick"  :props="jzProps"  accordion  node-key='id'>
						<span class="custom-tree-node" slot-scope="{ node, data }">
							<span>
								<i v-if="!data.parentId && !data.isJz"  class="el-icon-office-building"></i>
								<i v-if="data.parentId"  class="el-icon-location-outline"></i>
								<i v-if="data.isJz"  class="el-icon-coin"></i>
								{{ data.departmentName }}
							</span>

						</span>

					</el-tree>
				</el-popover>

			</el-form-item>
			<el-form-item>
				<el-input v-model="formInline.meterPointName"  @keyup.enter.native="getdata"  placeholder="请输入计量点名称" size="small"></el-input>
			</el-form-item>
      <el-form-item>
      	<el-input v-model="formInline.meterPoint"  @keyup.enter.native="getdata"  placeholder="请输入计量点地址" size="small"></el-input>
      </el-form-item>
			<el-form-item  label="选择数据项:" v-if="energyTypeStr != '水'">
				<el-select
					v-model="currEnergy"
					multiple
					collapse-tags
					size="small"
					style="margin-left: 20px;"
					placeholder="请选择"
					@change="dateItemChange"
					>
					<el-option
					  v-for="item in dataOptions"
					  :label="item.lable"
					  :key="item.prop"
					  :value="item.prop">
					</el-option>
				  </el-select>
			</el-form-item>
			<el-form-item>
				<el-button size="small"  type="primary" icon="el-icon-search" @click="getdata">搜索</el-button>
				<el-button size="small" type="success" icon="el-icon-download" :loading="downloadLoadin" @click="exportdata">导出</el-button>

			</el-form-item>

		</el-form>
		<el-form>

		</el-form>
		<el-table size="small" :data="listData" stripe :row-class-name="tableRowClassName"   :header-cell-style="this.$store.state.headerCss" ref="chaobTable" :max-height="tableHeight"  v-loading="loadingData" border element-loading-text="拼命加载中"
		 style="width: 100%;" >
			<el-table-column align="center" type="index" width="60" label="序号">
			</el-table-column>
			<template v-for="col in defaultCoulumn" >
				<el-table-column
          align="center"
					:prop="col.prop"
					:label="col.lable"
					:key="col.prop"
					:min-width="col.lable | getWidth"
          sortable
				>
				</el-table-column>
			</template>
		</el-table>
    <!-- 分页组件 -->
    <el-pagination
    v-if="showPage"
      @size-change="handleSizeChange"
     layout="total, sizes, prev, pager, next, jumper"
      :total="formInline.total"
      background
      :page-size="formInline.pageSize"
     	:current-page="1"
      :page-sizes="[ 30, 50, 100, 200,300,500]"
      style="margin-top: 20px;"
       @current-change="handleCurrentChange"
       >
    </el-pagination>


		<!-- 分页组件 -->
		<!-- <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination> -->

	</div>
</template>

<script>
	import {
		getRealTimeData
	} from '../../api/dataMG'
	import {

		getAllConfigurationList,
		getDepartmentTerminalInfoLis,
		getAllDataItemList,
		getTerminalInfoByDepId,
		getRealTimeDataPoiFiter

	} from '../../api/energyMG'
	import Pagination from '../../components/Pagination'
	export default {
		filters: {
			getWidth: function(val) {

				if( val == '费率' || val == '倍率'){
					return 90;
				}else if( val == '计量点名称' || val == '用能单位'){
					return 190;
				}else if(val == '采集时间'){
          return 130;
        }else if( val == '采集周期'){
          return 100
        }
				return 100


			}
		},
		data() {
			return {
				tableHeight:document.body.clientHeight-245,
				datatype: '',
				loading: false, //是显示加载
        loadingData:true,
				editFormVisible: false, //控制编辑页面显示与隐藏
				visible:false,
				title: '添加',
				getJZ:"",
        headerCss:this.$store.state.headerCss,
				downloadLoadin:false,
				jzProps:{
					label: function( data,node ){

					},
					children: 'deps',

				},
				// rules表单验证
				rules: {
					deptName: [{
						required: true,
						message: '请输入部门名称',
						trigger: 'blur'
					}],
					deptNo: [{
						required: true,
						message: '请输入部门代码',
						trigger: 'blur'
					}]
				},
         showPage :true,
				treeDate:[],
				formInline: {
					terIds:JSON.stringify([]),
					energyType:"",
					meterPointName:"",
          meterPoint:"",
          currentPage: 1,
          pageSize: 30,
          total:0,
				},
				// 删除部门
				seletedata: {
					ids: '',
					token: localStorage.getItem('logintoken')
				},
				energyTypeList: [], //能源类别
				currEnergy:[],
				listData: [], //用户数据
				// 分页参数
				pageparm: {
					currentPage: 1,
					pageSize: 10,
					total: 10
				},
				energyTypeStr:"",
				dataOptions:[],
				cols:[],
				tempCols: [],  //临时的数据容器
				defaultCoulumn:[


				],
				powerColumn:[

          {prop:"tipActivePowerMeterCode",lable:"尖正向有功表码"},
          {prop:"peakActivePowerMeterCode",lable:"峰正向有功表码"},
          {prop:"flatActivePowerMeterCode",lable:"平正向有功表码"},
          {prop:"ebbActivePowerMeterCode",lable:"谷正向有功表码"},

					// {prop:"forwardActivePowerMeterCode",lable:"正向有功表码"},
					{prop:"forwardReactivePowerMeterCode",lable:"正向无功表码(kWh)"},
					{prop:"reverseActivePowerMeterCode",lable:"反向有功表码(kWh)"},
					{prop:"reverseReactivePowerMeterCode",lable:"反向无功表码(kWh)"},
					{prop:"combinationActivePowerMeterCode",lable:"组合有功表码(kWh)"},
					{prop:"combinationReactivePowerMeterCode",lable:"组合无功表码(kWh)"},

					{prop:"APhaseVoltage",lable:"A相电压(V)"},
					{prop:"BPhaseVoltage",lable:"B相电压(V)"},
					{prop:"CPhaseVoltage",lable:"C相电压(V)"},

					{prop:"APhaseCurrent",lable:"A相电流(A)"},
					{prop:"BPhaseCurrent",lable:"B相电流(A)"},
					{prop:"CPhaseCurrent",lable:"C相电流(A)"},


          {prop:"psum",lable:"总有功功率"},
					{prop:"APhaseActivePower",lable:"A相有功功率"},
					{prop:"BPhaseActivePower",lable:"B相有功功率"},
					{prop:"CPhaseActivePower",lable:"C相有功功率"},
					{prop:"totalReactivePower",lable:"总无功功率"},
					{prop:"APhaseReactivePower",lable:"A相无功功率"},
					{prop:"BPhaseReactivePower",lable:"B相无功功率"},
					{prop:"CPhaseReactivePower",lable:"C相无功功率"},

					{prop:"powerFactor",lable:"总功率因数"},
					{prop:"APowerFactor",lable:"A功率因数"},
					{prop:"BPowerFactor",lable:"B功率因数"},
					{prop:"CPowerFactor",lable:"C功率因数"},




				],
				waterColumn:[
					// {prop:"discharge",lable:"水流量"},
					{prop:"waterCumulant",lable:"水累计量(m3)"},
					// {prop:"waterLevel",lable:"水位"},
					// {prop:"waterTemperature",lable:"水温"},
					// {prop:"hydraulicPressure",lable:"水压"},
					// {prop:"waterCumulantReverse",lable:"水累计量"}
				],

        heatEnergy:[
          { prop:"hotSettlingDayData",lable:'结算日热量'},
          { prop:"nowHotData",lable:"当前热量" },
          { prop:"hotPower",lable:"热功率" },
          { prop:"hotFlow",lable:"流量" },

          { prop:"supplyWaterTemp",lable:"供水温度" },
          { prop:"returnWaterTemp",lable:"回水温度" },
          { prop:"totalWorkTime",lable:"累积工作时间" },
          { prop:"statusST",lable:"状态" }

        ]
			}
		},
		// 注册组件
		components: {
			Pagination
		},
		/**
		 * 数据发生改变
		 */

		/**
		 * 创建完毕
		 */
		created() {
			this.initData()
      //this.headerCss = this.$store.state.headerCss

			this.getJZ = JSON.parse(sessionStorage.getItem('userdata')).departmentName

		},
		mounted(){


		},

		/**
		 * 里面的方法只有被调用才会执行
		 */
		methods: {

      handleSizeChange(val){

        this.formInline.pageSize = val
        this.getdata();
      },
      handleCurrentChange(e) {

      	this.formInline.currentPage = e
      	this.getdata();
      },

			getHeight(){
				this.$nextTick(() => {
					let out = this.$refs.chaobTable.$el.offsetTop + this.$refs.outBox.$el.offsetTop
					this.tableHeight = window.innerHeight - out - 50
				})
			},

			exportdata(){
				this.downloadLoadin = true
       
				getRealTimeDataPoiFiter(this.formInline).then(res => {

					var blob = new Blob([res], {type: 'application/vnd.openxmlformats-  officedocument.spreadsheetml.sheet;charset=utf-8'}); //type这里表示xlsx类型
					var downloadElement = document.createElement('a');
				　　var href = window.URL.createObjectURL(blob); //创建下载的链接
				　　downloadElement.href = href;
				　　downloadElement.download = 'result.xls'; //下载后文件名
				　　document.body.appendChild(downloadElement);
				　　downloadElement.click(); //点击下载
				　　document.body.removeChild(downloadElement); //下载完成移除元素
				　　window.URL.revokeObjectURL(href); //释放掉blob对象

					this.downloadLoadin = false

				}).catch(err => {
					this.downloadLoadin = false
					this.$message({
						message:'下载失败！',
						type:'error',
						showClose:true
					})
				})

			},

      tableRowClassName({row, rowIndex}){
        if (row.latestCollectTime == '--') {

          return 'warning-row';
        }
        return '';
      },

			initDefault:function(){
				let tempArr = [
					{prop:"meterPointName",lable:"计量点名称"},
					{prop:"energyUnit",lable:"用能单位"},
					{prop:"latestCollectTime",lable:"采集时间"},
          {prop:"meterPoint",lable:"计量点地址"},

					{prop:"magnification",lable:"倍率"},
					// {prop:"measureUnit",lable:"计量单位"},
					{prop:"collectCycle",lable:"采集周期"},
				]

				if(this.energyTypeStr == '电力'){
					tempArr.push(
            {prop:"rate",lable:"费率"},
            {prop:"forwardActivePowerMeterCode",lable:"正向有功表码(kWh)"}
          )
          this.defaultCoulumn = tempArr
				}else if( this.energyTypeStr == '水' ){
          tempArr.push({prop:"waterCumulant",lable:"水累计量(m3)"})
          this.defaultCoulumn = tempArr
        }else if( this.energyTypeStr ==  '热能' ){
          tempArr.push(

            { prop:"hotTotalFlow",lable:"累积流量" },

          )
          this.defaultCoulumn = tempArr
        }
			},

			//获取所有配置选项
			 getConfigData:function(){
				return new Promise((resolve,reject) => {
					getAllConfigurationList().then(res => {
						if(res.status == 1){
							this.energyTypeList = res.data.energyType

							//let currtypeId = res.data.energyType.filter( item => item.value == '电力')[0].id
							let currtypeId = this.energyTypeList[0].id
							let type = res.data.energyType[0].value
							this.energyTypeStr = res.data.energyType[0].value
							this.formInline.energyType = currtypeId

							this.checkCol(type)


							resolve(currtypeId)
						}else{
							this.$message.error(res.msg)
						}
					})
				})
			},

			checkCol:function(type){

				if(type == '电力'){
					this.dataOptions = this.powerColumn
				}else if(type == '水'){
					this.dataOptions = this.waterColumn
				}else if( type == '热能' ){
          this.dataOptions = this.heatEnergy
        }


			},

			handleNodeClick(data){

				this.visible = false
				this.getJZ = data.departmentName
				if(data.isJz){
					let idstr = JSON.stringify([{id:data.id}])
					this.formInline.terIds = idstr
          this.search()
				}else{
					//点击部门获得集中器id
					this.getDepIds(data.id);
				}



			},

      getDepIds(id){
        getTerminalInfoByDepId({depId:id}).then(res => {
        	if(res.status == 1){
        		let arr = []
        		res.data.forEach( item => {
        			let obj = {}
        			obj.id = item
        			arr.push(obj)
        		})

        		this.formInline.terIds = JSON.stringify(arr)
            this.search()

        	}else{
        		this.$message.error(res.msg)
        	}
        })
      },


			changeEnergy( val ){
				let lable = this.energyTypeList.filter(item => item.id == val)


				this.currEnergy = [];
				this.energyTypeStr = lable[0].value
				this.initDefault();
				this.getdata();

				this.checkCol(lable[0].value)

			},

			dateItemChange:function(val){
				let col = val
			    let arr = []
				this.dataOptions.forEach(item => {
					col.forEach(sitem => {
						if(item.prop == sitem){
							arr.push(item)
						}
					})
				})

				this.initDefault();
				this.defaultCoulumn = [...this.defaultCoulumn,...arr]


			},

			// getDataItemList:function(eType){
			//
			// 	getAllDataItemList({energyType:eType}).then(res =>{
			// 		if(res.status == 1){
			// 			this.dataItemList = res.data.treeList
			// 			this.defaultItems = res.data.ids
			// 			this.showDataItemInfo = '共'+ res.data.ids.length+'项数据，点击查看'
			//
			// 			this.jlEditParmater.dataItem = this.defaultItems.join('-')
			// 		}
			// 	})
			// },





			//获取集中器信息
			getJzData:function(){
				return new Promise((resolve,reject) => {
					getDepartmentTerminalInfoLis().then(res => {
						if(res.status == 1){
							let arr = []
							this.treeDate = this.changeData(res.data.menuDepList)
							this.getDepIds(JSON.parse(sessionStorage.getItem('userdata')).departmentId);
							resolve()
						}
						else{
							this.$message.error(res.msg)
						}
					})
				})

			},

			changeData( data ){
				data.forEach(item =>{
					if( item.terminalInfo){
						if(!item.deps){
							item.deps = []
						}
						item.terminalInfo.forEach(sitem => {
							let obj = {}
							obj.id = sitem.id
							obj.departmentName = sitem.terminalName
							obj.terminalCode = sitem.terminalCode
							obj.isJz= true
							item.deps.push(obj)
						})
					}

					if( item.deps){
						this.changeData(item.deps)
					}
				})

				return  data
			},

			async initData(){
				await this.getConfigData();
				await this.getJzData();
				this.initDefault();
				this.getdata();

			},



			getdata() {
				this.loadingData = true
				getRealTimeData(this.formInline).then(res => {
          this.loadingData = false
					if(res.status == 1){
						this.listData = res.data.result
            this.formInline.total = res.data.totalCount
					}else{
						this.$message.error(res.msg)
					}
				})


			},
			// 分页插件事件
			callFather(parm) {
				this.formInline.page = parm.currentPage
				this.formInline.limit = parm.pageSize
				this.getdata(this.formInline)
			},
			// 搜索事件
			search() {
        this.formInline.currentPage = 1
        this.showPage = false
        this.$nextTick(()=>{
          this.showPage = true
        })

				this.getdata(this.formInline)
			},
			//显示编辑界面
			handleEdit: function(index, row) {
				this.editFormVisible = true
				if (row != undefined && row != 'undefined') {
					this.title = '修改'
					this.editForm.deptId = row.deptId
					this.editForm.deptName = row.deptName
					this.editForm.deptNo = row.deptNo
				} else {
					this.title = '添加'
					this.editForm.deptId = ''
					this.editForm.deptName = ''
					this.editForm.deptNo = ''
				}
			},
			// 编辑、增加页面保存方法
			submitForm(editData) {
				this.$refs[editData].validate(valid => {
					if (valid) {
						deptSave(this.editForm)
							.then(res => {
								this.editFormVisible = false
								this.loading = false
								if (res.success) {
									this.getdata(this.formInline)
									this.$message({
										type: 'success',
										message: '公司保存成功！'
									})
								} else {
									this.$message({
										type: 'info',
										message: res.msg
									})
								}
							})
							.catch(err => {
								this.editFormVisible = false
								this.loading = false
								this.$message.error('公司保存失败，请稍后再试！')
							})
					} else {
						return false
					}
				})
			},
			// 删除公司
			deleteUser(index, row) {
				this.$confirm('确定要删除吗?', '信息', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					})
					.then(() => {
						deptDelete(row.deptId)
							.then(res => {
								if (res.success) {
									this.$message({
										type: 'success',
										message: '公司已删除!'
									})
									this.getdata(this.formInline)
								} else {
									this.$message({
										type: 'info',
										message: res.msg
									})
								}
							})
							.catch(err => {
								this.loading = false
								this.$message.error('公司删除失败，请稍后再试！')
							})
					})
					.catch(() => {
						this.$message({
							type: 'info',
							message: '已取消删除'
						})
					})
			},
			// 关闭编辑、增加弹出框
			closeDialog() {
				this.editFormVisible = false
			}
		}
	}
</script>

<style>
  .el-popover{
    max-height: 260px !important;
    overflow-y: scroll;
  }

	.user-search {

	}

	.userRole {
		width: 100%;
	}
	.cp .el-input__inner{
		cursor: pointer;
	}
  .el-table .warning-row {
      color: #F56C6C;

    }

  .el-tree-node.is-expanded>.el-tree-node__children{
     max-height: 360px;
     overflow: auto;
   }

</style>



// WEBPACK FOOTER //
// src/views/datamonitoring/realTime.vue